import React from 'react';
import { EditPanelFilterAsyncSelect } from '../../../components/utils/editPanel/EditPanelFilterAsyncSelect';
import { searchStreet } from './searchStreet';

export function EditPanelStraatBagSelect(props: { value: string | undefined; onChange: (value: string | undefined) => void }) {
    return (
        <EditPanelFilterAsyncSelect
            // eslint-disable-next-line @typescript-eslint/require-await
            loadOptions={async (inputValue: string) => searchStreet(inputValue).map((v) => ({ value: v, label: v }))}
            onChange={(value: string | undefined) => props.onChange(value ?? undefined)}
            placeholder="Zoek"
            value={{ label: props.value ?? '' }}
        />
    );
}
